import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { WizardComponent } from 'angular-archwizard';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { concat, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Cliente } from '../../core/model/cliente';
import { Direcciones } from '../../core/model/direcciones';
import { Instruccion, InstruccionRequest } from '../../core/model/instrucciones';
import { Materiales } from '../../core/model/materiales';
import { ServiceConfig } from '../../core/model/service-config';
import { Solicitud } from '../../core/model/solicitud';
import { SolicitudMateriales } from '../../core/model/solicitud-materiales';
import { EntregaServicio, TiposServicio, TratamientoServicio } from '../../core/model/tipo-servicio';
import { Userprofile } from '../../core/model/users';
import { UsuarioCliente } from '../../core/model/usuario-cliente';
import { AlbaranService } from '../../core/services/albaran.service';
import { AuthenticationService } from '../../core/services/authentication.service';
import { ClientesService } from '../../core/services/clientes.service';
import { DireccionesService } from '../../core/services/direcciones.service';
import { InstruccionesService } from '../../core/services/instrucciones.service';
import { MaterialesService } from '../../core/services/materiales.service';
import { ObservacionesSolicitudService } from '../../core/services/observaciones-solicitud.service';
import { ParametrosServicioService } from '../../core/services/parametros-servicio.service';
import { ServiceConfigService } from '../../core/services/service-config.service';
import { SessionService } from '../../core/services/session.service';
import { SolicitudServicioService } from '../../core/services/solicitud-servicio.service';
import { TipoServicioService } from '../../core/services/tipo-servicio.service';
import { UsersService } from '../../core/services/users.service';
import { DireccionSolicitudesComponent } from '../direccion-solicitudes/direccion-solicitudes.component';

@Component({
  selector: "app-materiales",
  templateUrl: "./materiales.component.html",
  styleUrls: ["./materiales.component.css"]
})
export class MaterialesComponent implements OnInit {
  @ViewChild("wizardMaterials") wizard: WizardComponent;
  @ViewChild("tableMateriales") tableMateriales: DatatableComponent;

  title: string;
  description: string;
  padre: string;
  hijo: string;

  isDocoutUser: boolean;
  isSupervisor = false;

  loading = false;

  direccionTemplate: BsModalRef;
  direcciones: Direcciones[];
  direccionSeleccionada: Direcciones;

  clientes: Cliente[] = [];
  clienteSeleccionado = undefined;
  hasClients = false;

  usuarioSeleccionado = undefined;
  usuarios: UsuarioCliente[] = [];
  usuario = 0;

  isValidQuality = true;
  hasMaterialSelected = true;

  instruccion: string;
  stepTitle: string;

  tableVisible = false;

  materiales: Materiales[] = [];
  materialSelected: Materiales | number = 0;
  materialValue: string;

  observaciones: string;

  errorCodes = [];
  errors = [];
  showError = false;

  unidades = [];
  pageNumber = 10;

  tiposServicio: TratamientoServicio[] = [];

  tipoEntrega: string;
  tipoEnvio: string;

  tiposEnvio: string[] = [];
  tiposEntrega: EntregaServicio[] = [];

  user: Userprofile;

  solicitud = new Solicitud();

  solicitudId: number = undefined;

  configServicio: ServiceConfig;
  isSsoAuthenticate = this.authService.isSsoAuthentication();


  emailForm = this.fb.group({
    email: [
      { value: '', disabled: this.isSsoAuthenticate},
      [Validators.required, Validators.email, Validators.maxLength(50)]
    ]
  });

  showErrorRepeatedMaterial = false;

  reintentado = false;

  get email() {
    return this.emailForm.get("email");
  }

  constructor(
    private authService: AuthenticationService,
    private translateService: TranslateService,
    private instruccionesService: InstruccionesService,
    private clientesService: ClientesService,
    private usersService: UsersService,
    private materialsService: MaterialesService,
    private modalService: BsModalService,
    private direccionesService: DireccionesService,
    private tipoServicioService: TipoServicioService,
    private fb: FormBuilder,
    private solicitudServicioService: SolicitudServicioService,
    private observacionesSolicitudService: ObservacionesSolicitudService,
    private cdRef: ChangeDetectorRef,
    private serviceConfigService: ServiceConfigService,
    private albaranService: AlbaranService,
    private sessionService: SessionService
  ) {}

  openModal() {
    this.direccionTemplate = this.modalService.show(
      DireccionSolicitudesComponent,
      { class: "modal-dialog modal-lg" }
    );
    this.direccionTemplate.content.closeBtnName = "Cerrar";
    this.direccionTemplate.content.direcciones = this.direcciones;
    this.direccionTemplate.content.idUsuario =
      this.isDocoutUser || this.isSupervisor
        ? this.usuarioSeleccionado
        : undefined;
    this.modalService.onHide.subscribe(result => {
      if (this.direccionTemplate.content.nuevaDireccion) {
        this.direccionSeleccionada = this.direccionTemplate.content.nuevaDireccion;
      }
    });
  }

  showTable() {
    this.tableVisible = true;
  }

  hideTable() {
    this.tableVisible = false;
  }

  private init() {
    if (this.authService.getUserId() != undefined) {
      this.setEnviroment();
      this.initLanguage();

      this.authService.isDocOutUser().then((isDocUser: boolean) => {
        this.isDocoutUser = isDocUser;
        this.verifyDocoutUser();
      });
    }
  }

  private verifyDocoutUser() {
    if (this.isDocoutUser) {
      this.clientesService.getAllClientes().subscribe((clientes: Cliente[]) => {
        this.clientes = clientes;
        this.hasClients = true;
      });
    } else {
      this.manageUserSupervisor();
      this.getMaterials(this.sessionService.getClientId());
      this.getDirecciones(this.authService.getUserId());
      this.getTipoTratamiento(0);
    }
  }

  private manageUserSupervisor() {
    this.isSupervisor =
      this.authService.isSupervisorUser() || this.authService.isAdminUser();
    if (this.isSupervisor) {
      this.getUsersByClient(this.sessionService.getClientId());
    }
  }

  private getTipoTratamiento(clientId: number) {
    this.tipoServicioService
      .getServicesType(clientId, "materiales")
      .subscribe((result: TiposServicio) => {
        if (result !== null && result !== undefined) {
          this.tiposServicio = result.tratamientosServicio.filter(
            tipo => tipo.tipoServicio === "MATERIALES"
          );
          const tipoEnviosReplicados = this.tiposServicio.map(
            tipoServicio => tipoServicio.tipoEnvio
          );
          this.tiposEnvio = tipoEnviosReplicados.filter(
            (v, i, a) => a.indexOf(v) === i
          );
        }
        this.tiposEntrega = result.entregaServicio.filter(
          param => param.parametro === "NORMAL" || param.parametro === "URGENTE"
        );
        this.initRadioButtons();
      });
  }

  private initRadioButtons() {
    if (this.tiposEntrega.length === 1) {
      this.tipoEntrega = this.tiposEntrega[0].parametro;
    }
    if (this.tiposEnvio.length === 1) {
      this.tipoEnvio = this.tiposEnvio[0];
    }
  }

  private getMaterials(clientId: number) {
    this.materialsService
      .getMaterialsByClient(clientId)
      .subscribe((materials: Materiales[]) => {
        this.materiales = materials;
      });
  }

  private getDirecciones(usuarioId: number) {
    this.usersService
      .getUserById(usuarioId)
      .subscribe((profile: Userprofile) => {
        this.configServicio = this.serviceConfigService
          .getServiceConfig()
          .serviceConfigs.find(
            (c: ServiceConfig) => c.servicio === "materiales"
          );
        this.user = profile;
        if (this.isDocoutUser) {
          this.direccionesService
            .getDirsOfSuplantedUser(usuarioId)
            .subscribe((result: Direcciones[]) => {
              this.assignDirs(result, "POR_DEFECTO");
            });
        } else {
          this.assignDirs(profile.DIRECCIONES, "DEFAULT");
        }
      });
  }

  private assignDirs(dirs: Direcciones[], propertyDefault: string) {
    this.direcciones = dirs;
    if (dirs.length == 1) {
      this.direccionSeleccionada = dirs[0];
    } else if (dirs !== null) {
      this.direccionSeleccionada = this.direcciones.find(
        direc => direc[propertyDefault]
      );
    } else {
      this.direcciones = [];
      this.direccionSeleccionada = undefined;
    }
  }

  ngOnInit() {
    this.init();
  }

  private setEnviroment() {
    this.authService
      .getClienteName$()
      .subscribe(beadcrumbDad => {
        this.padre = beadcrumbDad;
      })
      .unsubscribe();
  }

  private initLanguage() {
    this.translateService.get(["materiales"]).subscribe(values => {
      this.translateText(values);
    });

    this.translateService.onLangChange.subscribe(() => {
      this.translateService.get(["materiales"]).subscribe(values => {
        this.translateText(values);
      });
    });
  }

  private translateText(values: any) {
    this.title = values["materiales"]["cabecera"];
    this.description = values["materiales"]["descripcion"];
    this.hijo = values["materiales"]["cabecera"];
  }

  getInstruccion(stepId) {
    if (
      (stepId === 1 &&
        (this.clienteSeleccionado === undefined ||
          this.clienteSeleccionado == 0) &&
        (this.isDocoutUser !== undefined && this.isDocoutUser)) ||
      !this.wizard
    ) {
      return;
    }
    const request = new InstruccionRequest();
    request.ID_PASO = stepId;
    request.ROUTE = "materiales";
    request.PREFIJO_IDIOMA = this.translateService.defaultLang;
    request.ID_CLIENTE = this.isDocoutUser ? this.clienteSeleccionado : 0;
    this.instruccionesService
      .getServicesType(request)
      .subscribe(
        (result: Instruccion) =>
          (this.instruccion = result ? result.MENSAJE : null)
      );
    const step = this.wizard.wizardSteps.find(s => s.stepId == stepId);
    this.stepTitle = step.stepTitle;
    this.cdRef.detectChanges();
  }

  procesarClienteSeleccionado() {
    this.usuarioSeleccionado = undefined;
    if (!this.clienteSeleccionado) {
      this.resetClientZero();
    } else {
      this.getInstruccion(1);
      this.getMaterials(this.clienteSeleccionado);
      this.getTipoTratamiento(this.clienteSeleccionado);
      this.resetUserZero();
    }
    this.getUsersByClient(+this.clienteSeleccionado);
  }

  private getUsersByClient(clientId: number) {
    this.usersService
      .getUsersByClient(clientId)
      .subscribe((users: UsuarioCliente[]) => {
        if (this.isSupervisor) {
          this.usuarioSeleccionado = this.authService.getUserId();
        }
        this.usuarios = users;
      });
  }

  procesarUsuarioSeleccionado() {
    if (this.usuarioSeleccionado !== undefined) {
      this.getDirecciones(this.usuarioSeleccionado);
    } else {
      this.resetUserZero();
    }
  }

  private resetClientZero(resetMaterials?: boolean) {
    this.usuarios = [];
    this.usuarioSeleccionado = undefined;
    this.materiales = [];
    this.instruccion = undefined;
    this.resetUserZero();
  }

  private resetUserZero(dir: boolean = true) {
    // 🐱‍👤 08/11/2019 => He modificado para que el boton limpiar no limpie la dirección
    if (dir) {
      this.direcciones = [];
      this.direccionSeleccionada = undefined;
    }
    this.isValidQuality = true;
    this.resetMaterials();
  }
  private resetMaterials() {
    this.materialValue = undefined;
    this.materialSelected = 0;
  }

  checkIsDouble(doubleNumber: string) {
    this.isValidQuality =
      parseFloat(doubleNumber) != 0 &&
      !!doubleNumber.match(/^[0-9]{1,4}([,.][0-9]{1,2})?$/g);
    if (this.isValidQuality) {
      this.materialValue = this.materialValue.replace(",", ".");
    }
  }

  clean() {
    this.clienteSeleccionado = undefined;
    if (this.isDocoutUser) {
      this.usuarios = [];
      this.resetClientZero(false);
      return;
    }
    if (this.isSupervisor) {
      this.usuarioSeleccionado = undefined;
      this.resetUserZero(false);
      return;
    }
    this.resetMaterials();
  }

  onResizedMateriales(event): void {
    if (this.tableMateriales !== undefined) {
      setTimeout(() => {
        this.tableMateriales.recalculate();
        window.dispatchEvent(new Event("resize"));
      }, 50);
    }
  }

  addMaterial() {
    if (!this.materialValue) {
      this.isValidQuality = false;
    }

    if (this.materialSelected == 0) {
      this.hasMaterialSelected = false;
    }

    if (this.isValidQuality && this.hasMaterialSelected) {
      this.showErrorRepeatedMaterial = false;
      if (
        this.unidades.find(unidad => unidad.Id === this.materialSelected["Id"])
      ) {
        this.showErrorRepeatedMaterial = true;
        return;
      }
      const newUnity = {
        Id: this.materialSelected["Id"],
        NOMBRE: this.materialSelected["DESCRIPCION"],
        CANTIDAD: this.materialValue
      };
      this.unidades = [...this.unidades, newUnity];
      this.materialSelected = 0;
      this.materialValue = undefined;
      return;
    }
    this.showError = true;
    setTimeout(() => {
      this.showError = false;
    }, 3000);
  }

  borrarUnidad(row) {
    const index = this.unidades.indexOf(row);
    if (index > -1) {
      this.unidades.splice(index, 1);
    }
    this.unidades = [...this.unidades];
  }

  setHasMaterialSelected(event) {
    this.hasMaterialSelected = event.currentTarget.value != 0;
  }

  crearSolicitud() {
    this.loading = true;
    this.errors = [];
    this.errorCodes = [];
    this.solicitud.email = this.user.EMAIL;
    this.solicitud.manualMasiva = "MANUAL";
    this.solicitud.idDireccion = this.direccionSeleccionada.Id;
    this.solicitud.idTipoServicio = this.tiposServicio.filter(
      (tipo: TratamientoServicio) =>
        tipo.paramServicio === "ORIGINAL" && tipo.tipoEnvio === this.tipoEnvio
    )[0].id;
    this.solicitud.normalUrgente = this.tipoEntrega;
    if (this.isDocoutUser || this.isSupervisor) {
      this.solicitud.idSolicitante = this.usuarioSeleccionado;
    }
    this.solicitud.contenidosMateriales = this.unidades.map(unidad =>
      this.createSolicitudMaterial(unidad)
    );

    this.solicitudServicioService.crearSolicitud(this.solicitud).subscribe(
      (result: any) => {
        if (
          !result ||
          !result.ID_SOLICITUD_SERVICIO ||
          result.ID_SOLICITUD_SERVICIO <= 0
        ) {
          if (console) {
            // console.log('No se ha podido crear la solicitud');
          }
          this.errorCodes.push("SOLICITUD");
          // this.errorsToShow.push({ id: this.errorsToShow.length + 1, errorCode: 'SOLICITUD', errorElement: undefined });
          // this.errorsToShow = [...this.errorsToShow];
          this.loading = false;
        } else {
          this.solicitudId = result.ID_SOLICITUD_SERVICIO;
          const observables: Map<number, Observable<any>> = new Map();

          if (this.observaciones !== undefined && this.observaciones !== null) {
            observables.set(
              0,
              this.observacionesSolicitudService
                .addObservaciones(
                  this.solicitudId,
                  this.observaciones,
                  false,
                  this.user.Id,
                  false
                )
                .pipe(
                  catchError((response: Response) => {
                    return of(-1);
                  })
                )
            );
          }

          if (observables.size > 0) {
            let output: Observable<any> = observables.get(0);
            for (let x = 1; x < observables.size; x++) {
              output = concat(output, observables.get(x));
            }
            let indiceEjecucion = 0;
            output.subscribe(resultSecuencial => {
              if (resultSecuencial > 0) {
                if (console) {
                  // console.log('Observable ' + indiceEjecucion + ' ejecutado correctamente');
                }
                if (indiceEjecucion === observables.size - 1) {
                  this.loading = false;
                }
              } else {
                if (indiceEjecucion === observables.size - 1) {
                  if (this.observaciones) {
                    this.errorCodes.push("OBSERVACIONES");
                  } else {
                    this.errorCodes.push("CANTIDADES");
                    this.errors.push(this.unidades[indiceEjecucion]);
                  }
                  this.loading = false;
                }
              }
              indiceEjecucion++;
            });
          } else {
            // BUG 18/09/2019 => Si no tiene observaciones no habia un caso ELSE
            // y no se ocultaba el componente del loading
            this.loading = false;
          }
        }
      },
      error => {
        this.solicitudId = -1;
        if (console) {
          // console.log('No se ha podido crear la solicitud');
        }
        this.errorCodes.push("SOLICITUD");
        this.loading = false;
      }
    );
  }

  private createSolicitudMaterial(unidad): SolicitudMateriales {
    return {
      ID_CLIENTE: this.isDocoutUser
        ? this.clienteSeleccionado
        : this.sessionService.getClientId(),
      ID_MATERIAL: unidad.Id,
      CANTIDAD: unidad.CANTIDAD
    };
  }

  nuevaSolicitud() {
    this.direccionSeleccionada = undefined;
    this.direcciones = undefined;
    this.tiposServicio = [];
    this.tiposEnvio = [];
    this.tiposEntrega = [];
    this.unidades = [];
    this.tipoEntrega = undefined;
    this.tipoEnvio = undefined;
    this.tableVisible = false;
    this.solicitudId = undefined;
    this.observaciones = undefined;
    this.errorCodes = [];
    this.errors = [];
    this.init();
    this.instruccion = undefined;
    this.clienteSeleccionado = undefined;
    this.procesarClienteSeleccionado();
    this.wizard.navigation.reset();
  }

  getLanguageText(text: string): string {
    return this.translateService.instant(text);
  }

  getAlbaran() {
    this.albaranService.getAlbaranSolicitud(this.solicitudId);
  }

  reintentarCreacionSolicitud() {
    this.reintentado = true;

    this.crearSolicitud();
  }
}
